import { services } from "../../../../constants";
import { setCookie, getCookieByName } from "../../../../utils/cookiesUtils";

export default async function validateOtp(data) {
  const url = `${this.backendHosts.auth}${services.validateOtp}`;
  try {
    const response = await this.http.post(url, data, await this.getHeaders());
    const jwtCookie = this.jwtCookie;
    const spxToken = response && response.data && response.data.token.sessionToken;
    if (!getCookieByName(jwtCookie.name)) {
      console.log("enter in jwt cookie");
      setCookie(jwtCookie.name, response.data.token.jwtToken, jwtCookie.expirationTime);
      setCookie("spx-token", spxToken, jwtCookie.expirationTime);
      setCookie("UID", Date.now());
    }
    return response;
  } catch (error) {
    this.handleErrorResponse(error);
  }
}
